import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BsLocaleService, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ExportFilter } from 'src/app/models/export-filter';
import { CMSForm } from 'src/app/models/form';
import { FormDataService } from 'src/app/shared/forms/form-data.service';
import { FormsService } from 'src/app/shared/forms/forms.service';
import * as fromSettings from 'src/app/shared/state/setting.reducer';

@Component({
  selector: 'app-export-filter',
  templateUrl: './export-filter.component.html',
  styleUrls: ['./export-filter.component.scss']
})
export class ExportFilterComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  title = '';
  closeBtnName = '';
  isCollapsed = true;
  filter = new ExportFilter();
  fieldsPreselect = 'alle';

  states = [];
  forms: CMSForm[];

  areas: Array<{ id: string, title: string }> = [];
  regions: Array<{ id: string, title: string }> = [];
  supportMeasures: Array<{ id: string, title: string }> = [];
  places: Array<{ id: string, title: string }> = [];
  exportFields: Array<{ name: string, fields: string[] }> = [];
  dateCustomClasses: DatepickerDateCustomClasses[];

  availableFields = [
    { id: 'chapter', title: 'Kapitelnummer' },
    { id: 'name', title: 'Seminarbeschreibung' },
    { id: 'unitAmount', title: 'Unterrichtseinheiten' },
    { id: 'shortNumber', title: 'SeminarNr' },
    { id: 'manu', title: 'MaNu' },
    { id: 'mode', title: 'Art' },
    { id: 'licences', title: 'LizenzbereichsNr' },
    { id: 'start', title: 'SeminarStart' },
    { id: 'end', title: 'SeminarEnde' },
    { id: 'parts', title: 'Module mehrteilige Lehrgänge' },
    { id: 'location', title: 'Ort' },
    { id: 'bezirk', title: 'Bezirk' },
    { id: 'gau', title: 'Gau' },
    { id: 'minAge', title: 'Mindestalter' },
    { id: 'registerDate', title: 'Anmeldeschluss' },
    { id: 'registration', title: 'Meldeadresse' },
    { id: 'costBTV', title: 'PreisBTV' },
    { id: 'costOthers', title: 'PreisKeinMitglied' },
    { id: 'head', title: 'AdrNr' },
    { id: 'prerequisite', title: 'Zulassungsvoraussetzungen' },
    { id: 'content', title: 'SeminarbeschreibungDetail' },
    { id: 'additional', title: 'SeminarbeschreibungDetail2 (Sonstiges)' },
    { id: 'costUEBTV', title: 'Preise Unterrichtseinheiten Gaue Bezirke' },
  ]

  constructor(public bsModalRef: BsModalRef, private store: Store<fromSettings.SettingsState>,
    private localeService: BsLocaleService, private formDataService: FormDataService, private formsService: FormsService) { }

  ngOnInit() {
    this.store.select(fromSettings.getSettings).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      settings => {
        if (settings.length) {
          this.areas = settings.filter(item => item.name === 'MaNu3 Bereiche')[0]?.data || [];
          this.regions = settings.filter(item => item.name === 'MaNu2 Standorte')[0]?.data || [];
          this.supportMeasures = settings.filter(item => item.name === 'MaNu4 Fördermerkmal')[0]?.data || [];
          this.places = settings.filter(item => item.name === 'MaNu5 Durchführungsort')[0]?.data || [];
          this.exportFields = settings.filter(item => item.name === 'export Felder')[0]?.data || [];

          const allFields = this.exportFields.filter((item) => item.name === 'alle');
          if (allFields.length) {
            this.applyFieldList(allFields[0]);
          }
        }
      }
    );

    // ToDo: Get states during startup too.
    this.formDataService.states().subscribe(res =>
      this.states = res['states']
    );

    this.formsService.getForms().subscribe(res => this.forms = res.forms.filter(form => form.active == true && form.type === 'course'));

    this.localeService.use('de');

    const now = new Date();
    this.dateCustomClasses = [
      { date: now, classes: ['bg-warning'] },
    ];
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  download() {
    this.formDataService.export(this.filter).subscribe(res => {
      if (res.url) {
        window.open(res.url, '_blank');
      }
    });
    this.bsModalRef.hide();
  }

  applyFieldList(item) {
    this.filter.fields = [...item.fields];
  }

  selectField(field) {
    if (!this.filter.fields.includes(field)) {
      this.filter.fields.push(field);
    }
    else {
      const index = this.filter.fields.findIndex((id) => id === field);
      this.filter.fields.splice(index, 1);
    }
  }

  isFieldSelected(field) {
    return this.filter?.fields?.includes(field) || false;
  }

}
